module.exports = __webpack_public_path__ + "static/merch7Back-7b5ba04a0593d15842e9d51b5809187f.png";